<template>
  <settings-modal class="payment-ifast-api-retry-modal">
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <p class="subheading red--text text-darken-2 mb-0">Are you sure you want to retry this payment via iFast API?</p>

    <template slot="actions">
      <v-btn
        id="reject"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentIfastApiRetryModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        retryIfastApiWithdrawalByAccountant: new ApiRequest(PaymentApi.retryIfastApiWithdrawalByAccountant)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      heading () {
        return `Retry payment ${this.paymentId} via iFast API?`
      },
      loading () {
        return this.retryIfastApiWithdrawalByAccountant.loading
      },
      error () {
        return this.retryIfastApiWithdrawalByAccountant.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.retryIfastApiWithdrawalByAccountant
          .execute(this.paymentId)
          .then(this.retrySuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      retrySuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'A new iFast API request has been created.' }
          })
        }, 100)
      }
    }
  }
</script>

<style lang="scss">
.payment-ifast-api-retry-modal {
  &.settings-modal {
    .container {
      padding-bottom: 28px;
    }
  }
}
</style>
